const moduleName = "admin.pharmacist";

const $inject = [
  "$http",
  "$stateParams",
];

class PharmacistService {
  constructor(
    $http,
    $stateParams
  ) {
    this.$http = $http;
    this.$stateParams = $stateParams;
  }

  load_all() {
    //let self = this;
    const handleSuccess = function (response) {
      if (response.data.success) {
        return response.data.data;
      }
    };

    const handleError = function (response) {
    };

    return this.$http
      .get("/admin/pharmacist/data")
      .then(handleSuccess, handleError);
  }

  load_one(id) {
    function handleSuccess(response) {
      if (response.data.success) {

        for (let status of response.data.data.statuses) {
          if (response.data.data.pharmacist.status.id === status.id) {
            response.data.data.pharmacist.status = status;
          }
        }

        if (response.data.data.pharmacist.facilityProvider === null) {
        }
        else {
          for (let facility_provider of response.data.data.facility_providers) {
            if (response.data.data.pharmacist.facilityProvider.id === facility_provider.id) {
              response.data.data.pharmacist.facilityProvider = facility_provider;
            }
          }
        }

        const predicate = (prices, product) => prices.some(price => price.product.code === product.code);
        for (let product of response.data.data.products) {
          if (!predicate(response.data.data.pharmacist.prices, product)) {
            response.data.data.pharmacist.prices.push({
              id: null,
              product: product,
              price: null,
            });
          }
        }
        return response.data.data;
      }
    }

    function handleError(response) {
    }

    return this.$http
      .get("/admin/pharmacist/data/" + id)
      .then(handleSuccess, handleError);
  }

  update(pharmacist, handleSuccess, handleError) {
    pharmacist = angular.copy(pharmacist);
    delete pharmacist.accountHolder;
    delete pharmacist.pharmacistAccreditations;

    pharmacist.status = pharmacist.status.id;
    pharmacist.facilityProvider = pharmacist.facilityProvider? pharmacist.facilityProvider.id: null;
    pharmacist.facilities = pharmacist.facilities.map(facility => facility.id);
    pharmacist.prices = pharmacist.prices.filter(price => price.product.referral_type.code !== "RMMR" || pharmacist.facilityProvider);
    pharmacist.prices.forEach(price => price.product = price.product.id);

    delete pharmacist.name;
    for (let key in pharmacist) {
      if (key.match(/^has(_|[A-Z\d])/)) {
        delete pharmacist[key];
      }
    }
    delete pharmacist.training_video;

    return this.$http
      .post("/admin/pharmacist/data/update/" + pharmacist.id, {pharmacist})
      .then(handleSuccess, handleError);
  }
}

PharmacistService.$inject = $inject;

//noinspection JSValidateTypes
export default angular.module(moduleName, [])
  .service("AdminPharmacistService", PharmacistService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/admin/pharmacist.service.js
 **/